import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThemeService } from '../theme.service';
import { ThemeTokens } from '../theme.model';

@Component({
  selector: 'app-theme-switcher',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './theme-switcher.component.html',
  styleUrl:    './theme-switcher.component.scss',
})
export class ThemeSwitcherComponent {
  readonly themeSvc = inject(ThemeService);

  get themes(): ThemeTokens[] { return this.themeSvc.all; }
  get active(): ThemeTokens   { return this.themeSvc.current; }

  select(t: ThemeTokens): void { this.themeSvc.setTheme(t); }
}
